import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setPageTitle } from '../../../../../redux/slices/PageTitleSlice';
import OCPPLogs from '../../../../ocpp-logs';

import Operations from './Operations';

/**
 * Function to display OCPP console component.
 * @returns {any} The result
 */
export default function OcppConsole() {
  const { t } = useTranslation('devices');
  const dispatch = useAppDispatch();
  const [autoRefreshActive, setAutoRefreshActive] = useState<boolean>(false);
  const { selectedChargingPoint } = useAppSelector((state) => state.device);
  const chargingPointSn = selectedChargingPoint?.chargingPointSn || selectedChargingPoint?.name || '';

  /**
   * Callback when any OCPP action is triggered by the user.
   */
  const handleActionTriggered = () => {
    setAutoRefreshActive(true);
  };

  useEffect(() => {
    dispatch(setPageTitle(t('chargerManagement')));
  }, []);

  return (
    <div className="device-ocpp-console-wrap">
      <div className="device-ocpp-console-container">
        <Operations onActionTriggered={handleActionTriggered} />
      </div>
      <OCPPLogs
        chargingPointSn={chargingPointSn}
        autoRefreshEnabled={autoRefreshActive}
        hideAccountStationChargerFilters
      />
      <div />
    </div>
  );
}
